<template lang="pug">
#sidebar-container.desktop(:class="{ sticky: stickySideNav }")
  .nav-container
    ul.nav-item-list
      router-link(to="/happenings", @click="$ga.event('sidebar', 'click', 'sidebar-link.happenings')")
        li HAPPENINGS
      li.dash -
      router-link(to="/sale", @click="$ga.event('sidebar', 'click', 'sidebar-link.sale')")
        li SALE
      li.dash -
      li(@click="activateThemeSidebar", :class="{ active: $store.state.sidebarThemeActivated }") THEMES
      li.dash -
      router-link(to="/new", @click="$ga.event('sidebar', 'click', 'sidebar-link.new')")
        li NEW
    ul.filter-search
      li.sidebar-yellow(@click="changeTab('filter')", v-if="$store.state.sidebarMode !== 'searchOnly'" :class="{ 'active': $store.state.homepageSidebarTab === 'filter' }" gtm-label="sidebar.change-tab") FILTER
      li.sidebar-yellow(@click="changeTab('search')", :class="{ 'active': $store.state.homepageSidebarTab === 'search', 'tab-width': $store.state.sidebarMode === 'searchOnly' }" gtm-label="sidebar.change-tab") SEARCH
</template>

<script>
export default {
  props: ['stickySideNav'],
  methods: {
    activateThemeSidebar () {
      if (this.$store.state.sidebarThemeActivated) {
        this.$store.commit('setSidebarThemeState', false)
      } else {
        this.$store.commit('setSidebarThemeState', true)
      }

      if (this.$route.path !== '/') {
        this.$store.commit('setHomepageSidebarTab', '')
      }
    },

    changeTab (tab) {
      if (this.$store.state.homepageSidebarTab === tab && this.$route.path !== '/') {
        this.$store.commit('setHomepageSidebarTab', '')
      } else {
        this.$store.commit('setHomepageSidebarTab', tab)
      }

      if (this.$route.path === '/') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }

      this.$store.commit('setSidebarThemeState', false)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../sass/_variables.sass'

.tab-width
  width: 257px !important
  display: block

#sidebar-container
  background-color: white
  width: calc(100vh - 110px)
  transform: rotate(-90deg)
  position: absolute
  transform-origin: left top
  top: calc(100%)
  z-index: 10
  box-shadow: -2px 0px 1px 1px white
  &.sticky
    position: fixed
    top: calc(100% - 110px) // 110px = navbar height
  .nav-container
    display: flex
    ul
      display: flex
      width: 100%
      align-items: center
      li
        text-align: center
        font-weight: 900
        font-style: italic
        color: #212121
        cursor: pointer
        padding: 10px
        &.dash
          cursor: initial
          padding: 10px 0
        &.active
          background-color: $yellow

      &.filter-search
        width: 256px
        .sidebar-yellow
          background-color: $light-yellow
          box-shadow: -2px 0px 0px 0px white
          width: 128px
          &.active
            background-color: $yellow

      &.nav-item-list
        // justify-content: space-evenly
        display: flex
        li
          flex: 3
          &.dash
            flex: 1
        a
          flex: 3
</style>
